export default "__VITE_ASSET__CvjZawfK__"